import { ThemeUICSSObject } from '@apia/theme';
/* IMPORT HERE */

const apiaFunctions: ThemeUICSSObject = {
  /* PREPEND HERE */

  iframe: {
    border: 'none',
    height: '100%',
    width: '100%',
  },
};

export default apiaFunctions;
